import { User } from '../_models/user';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs';

/**
 * Classe
 */
@Injectable()
export class SessionService {
    /** xx */
    private _userSubject = new Subject<User>();
    /** xx */
    private _userData: User;
    /** xx */
    public _userObservable: Observable<User>;

    private _userClaims: any;

    constructor() {
        this._userObservable = this._userSubject.asObservable();
    }

    setUser(user: User) {
        this._userData = user;
        this._userSubject.next(user);
    }

    setClaims(claims: any) {
        this._userClaims = claims;
    }

    getClaims() {
        return this._userClaims;
    }

    getUser() {
        return this._userObservable.map(user => {
            this._userData = user;
            return user;
        });
    }

    getUser1() {
        return this._userData;
    }

    getToken() {
        if (this._userData) {
            // return this._userData.token;
        }
    }
}
